export default __webpack_public_path__ + "static/media/NEHA RAMYA.02acdcd4.jpg";